import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RentalCarService } from '../../business-services/rental-car.service';


@Injectable({ providedIn: 'root' })
export class EditRentalCarGuard  {

  constructor(
    private EditRentalCar: RentalCarService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.EditRentalCar.RentalCarId) {
      return true;
    }
    return this.router.createUrlTree(['/rentalvehicle']);
  }
}
